import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AllergenNutritionFlavorService, IAllergen, IAllergenConfig, IFindAllergen, IFindNutrition, INutrition, INutritionConfig } from '../../services/allergen-nutrition-flavor.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ModalController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { IStore, StoreService } from 'src/app/store/services/store.service';
import { finalize } from 'rxjs';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ItemContentDetailsModalComponent } from 'src/app/shared/modals/item-content-details-modal/item-content-details-modal.component';

@Component({
  selector: 'app-nutrition-allergy-page',
  templateUrl: './nutrition-allergy-page.component.html',
  styleUrls: ['./nutrition-allergy-page.component.scss'],
  standalone: false
})
export class NutritionAllergyPageComponent  implements OnInit {

  stores: IStore[] = [];

  nutritions: INutrition;
  allergens: IAllergen;

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  findNutrition: IFindNutrition = {
    merchantId: "",
    deepSearch: false,
    itemIds: [],
    page: 0,
    pageSize: 0
  };

  findAllergen: IFindAllergen = {
    merchantId: "",
    deepSearch: false,
    itemIds: [],
    page: 0,
    pageSize: 0
  };

  viewNutrition: boolean = true;

  @ViewChildren('headerText') texts!: QueryList<ElementRef>;
  @ViewChildren('headerCell') cells!: QueryList<ElementRef>;

  selectedStore: IStore;
  isOpen: boolean = false;

  constructor(
    private allergenNutritionFlavorService: AllergenNutritionFlavorService,
    public settings: SettingService,
    private modalCtrl: ModalController,
    public translationService: TranslationService,
    private storeService: StoreService,
    private loaderService: LoaderService,
  ) { }

  async ngOnInit() {

    this.getStores();
    if(this.settings.configuration.uIoptions?.showNutritionsTable && this.settings.configuration.uIoptions?.showAllergiesTable) {
      this.getAllNutritions();
      this.getAllAllergens();
      this.viewNutrition = true;
    } else {
      if (this.settings.configuration.uIoptions?.showNutritionsTable) {
        this.getAllNutritions();
        this.viewNutrition = true;
      } else if(this.settings.configuration.uIoptions?.showAllergiesTable) {
        this.getAllAllergens();
        this.viewNutrition = false;
      }
    }
    
    

    /*
    this.getAllNutritions();
    this.getAllAllergens();
    */

    if (window.innerWidth <= 500) {
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }



    // test the API, once tested, we'll use it directly from SMS and not pass through shopachat
    /*
    var itemId: "";
    
    this.storeService.getItem(itemId);
    */
  }

  ngAfterViewInit() {
    this.texts.forEach((text, i) => {
      const rect = text.nativeElement.getBoundingClientRect();
      const cell = this.cells.toArray()[i].nativeElement;

      cell.style.width = `${rect.width + 32}px`;
      cell.style.height = `${rect.height + 4}px`;
    });
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 

    if (window.innerWidth <= 500) { // follows the value of the modal
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }
  }

  @HostListener('document:click')
  closeDropdown() {
    this.isOpen = false;
  }

  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }

  selectStore(store?: IStore) {
    if(store) {
      this.selectedStore = store;
      this.isOpen = false;
    } else {
      this.selectedStore = null;
      this.isOpen = false;
    }
    
  }

  getAllNutritions(){
    this.fetchNutritions().subscribe(async nutrition => {
      this.nutritions = nutrition;

      console.log(this.nutritions);
    });
  }

  fetchNutritions() {

    this.findNutrition.merchantId = this.settings.getMerchantId();
    this.findNutrition.deepSearch = false;
    this.findNutrition.itemIds = [];
    this.findNutrition.page = 0;
    this.findNutrition.pageSize = 0;
    

    return this.allergenNutritionFlavorService.getNutritions(this.findNutrition);
  }

  getAllAllergens(){
    this.fetchAllergens().subscribe(async allergens => {
      this.allergens = allergens;

      console.log(this.allergens);
    });
  }

  fetchAllergens() {
    this.findAllergen.merchantId = this.settings.getMerchantId();
    this.findAllergen.deepSearch = false;
    this.findAllergen.itemIds = [];
    this.findAllergen.page = 0;
    this.findAllergen.pageSize = 0;
    

    return this.allergenNutritionFlavorService.getAllergens(this.findAllergen);
  }


  toggleTable(isNutrition: boolean) {
    this.viewNutrition = isNutrition;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // store data processing

  async getStores() {
    console.log("collecting stores")
    const loader = await this.loaderService.create();

    this.storeService.getStores()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe((data: IStore[]) => {
        //console.log(data);
        this.stores = data;

        console.log(this.stores);
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // nutrition data processing

  getIteNutritionName(itemId: string): string {
    const item = this.nutritions.items.find(i => i.itemId === itemId);
    Math.floor
    return item.item.itemName.translations[this.translationService.getLanguage()];
  }

  getItemNutritionValue(itemId: string, nutrition: INutritionConfig): number {
    const itemData = nutrition.itemValues.find(i => i.itemId === itemId);
    if(itemData) {
      return itemData.value;
    } else {
      return 0; // default value if there's no fields for it from the db
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // allergen data processing

  getItemAllergenName(itemId: string): string { 
    const item = this.allergens.items.find(i => i.itemId === itemId);
    Math.floor
    return item.item.itemName.translations[this.translationService.getLanguage()];
  }

  getItemAllergenValue(itemId: string, allergen: IAllergenConfig): number {
    const itemData = allergen.itemValues.find(i => i.itemId === itemId);
    if(itemData) {
      return itemData.value;
    } else {
      return 0; // default value if there's no fields for it from the db
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////

  async openItemContentDetails(contentType: string, itemId: string) {
    const modal = await this.modalCtrl.create({
      component: ItemContentDetailsModalComponent,
      componentProps: {
        contentDisplayType: contentType, // here it could be "all, nutrition, allergen and flavor"
        ItemId: itemId
      },
      cssClass: 'item-content-detail-modal-css'
    })

    modal.onWillDismiss()
    .then(async (result) => {
      if (result.data) { 
        
      }
    });

    await modal.present();
  }
}
